import { render } from "./ProjectsSummary.vue?vue&type=template&id=6dd4657f&scoped=true"
import script from "./ProjectsSummary.vue?vue&type=script&lang=js"
export * from "./ProjectsSummary.vue?vue&type=script&lang=js"

import "./ProjectsSummary.vue?vue&type=style&index=0&id=6dd4657f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd4657f"]])

export default __exports__